import {billingAddressGet} from "./WoodGreenPaymentsApi";

export const hostedFieldsCreate = (clientToken) => {
  const years = []
  const date = new Date()

  for (let currentOffset = 0; currentOffset < 5; currentOffset++) {
    years.push((date.getFullYear() + currentOffset).toString())
  }

  return braintree.hostedFields.create({
    authorization: clientToken,
    styles: {
      'input': {
        'font-size': '14px',
      },
      'input.invalid': {
        'color': 'red'
      },
      'input.valid': {
        'color': 'green'
      }
    },
    fields: {
      number: {
        container  : '#card-number',
        placeholder: '4111 1111 1111 1111',
      },
      cvv: {
        container  : '#cvv',
        placeholder: '123',
      },
      expirationMonth: {
        container: '#expiration-date-month',
        select   : [1,2,3,4,5,6,7,8,9,10,11,12]
      },
      expirationYear: {
        container  : '#expiration-date-year',
        select   : years
      },
    }
  })
}

export const threeDSecureCreate = (clientToken) => {
  return braintree.threeDSecure.create({
    authorization: clientToken,
    version      : 2
  })
}

export const brainTreeCreate = (clientToken, googleMerchantId = null) => {
  return new Promise((resolve, reject) => {
    Promise.all([
      hostedFieldsCreate(clientToken),
      threeDSecureCreate(clientToken),
      dataCollectorCreate(clientToken),
      paypalCheckoutCreate(clientToken),
      applePayCheckoutCreate(clientToken),
      googlePayCheckoutCreate(clientToken, googleMerchantId)
    ])
    .then(instances => {
      const hostedFields = instances[0]
      resolve({ 'hostedFields': hostedFields, 'threeDSecure': instances[1], dataCollector: instances[2], googlePayCheckoutInstance: instances[5], paypalCheckoutInstance: instances[3], applePayCheckoutInstance: instances[4]})
    })
    .catch(error => {
      console.error('brainTreeCreate error:', error)
      reject()
    })
  })
}

export const applePayCheckoutCreate = clientToken => {
  return new Promise((resolve, reject) => {
    braintree.client.create({authorization: clientToken})
      .then(clientInstance => {
        return braintree.applePay.create({
          client: clientInstance
        })
      })
      .then(applePayInstance => {
        resolve(applePayInstance)
      })
      .catch(error => reject(error))
  })
}

export const googlePayCheckoutCreate = (clientToken, googleMerchantId) => {

  console.log('googleMerchantId', googleMerchantId)

  return new Promise((resolve, reject) => {
    braintree.client.create({authorization: clientToken})
      .then(clientInstance => {
        return braintree.googlePayment.create({
          client          : clientInstance,
          googlePayVersion: 2,
          googleMerchantId: googleMerchantId
        })
      })
      .then(paymentInstance => {
        if (paymentInstance) {
          resolve(paymentInstance)
        }
        else {
          reject('GooglePay client error')
        }
      })
      .catch(error => reject(error))
  })
}

//
//   const googlePaymentsClient = new google.payments.api.PaymentsClient({
//     environment: 'TEST'
//   })
//
//
//   return new Promise((resolve, reject) => {
//     braintree.client.create({
//       authorization: CLIENT_AUTHORIZATION
//     }, function (clientErr, clientInstance) {
//   })
// }

export const paypalCheckoutCreate = clientToken => {
  return braintree.paypalCheckout.create({
    authorization: clientToken
  })
}

export const dataCollectorCreate = (clientToken) => {
  return braintree.dataCollector.create({
    authorization: clientToken,
  })
}

export const threeDSecureVerifyCard = (payload, values, donationFeeRate) => {

  const totalPrice = (donationFeeRate && values.cover_donation_fee === 'Y')
  ? (parseFloat(values.payment_amount) * donationFeeRate).toFixed(2).replace('.00', '')
  : values.payment_amount;

  const ip = window.ipAddress
  console.log(ip)

  const output = {
    onLookupComplete: (data, next) => {
      next();
    },
    amount: totalPrice,
    nonce : payload.nonce,
    bin   : payload.details.bin,
    email : values.email,
    billingAddress: billingAddressGet(values),
    additionalInformation: {
      ipAddress: ip,
    },
    collectDeviceData: true
  }

  console.log(output)
  return output
}
